export default "__VITE_ASSET__c3d1b0b6__"